import { getLocalStorage } from "./storage"

export const getCleengCredentials = () => {
    const tokens = {
        refreshToken: getLocalStorage("CLEENG_REFRESH_TOKEN", true),
        jwtToken: getLocalStorage("CLEENG_AUTH_TOKEN", true),
    }
    return tokens;
}